import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { gsap } from "gsap";
import { motion, useScroll, useTransform } from 'framer-motion';
import { animateScroll as scroll } from "react-scroll";
import { IoIosArrowDown } from "react-icons/io";
import Header from "./Header";
import Image from "../assets/img/house-banner.jpg"; 

const Banner = () => {
  const [isMobile, setIsMobile] = useState(false);
  const btnHouseRef = useRef(null);
  const containerRef = useRef(null);
  const arrowBtnRef = useRef(null);

  const scrollToNextSection = () => {
    const nextSection = document.getElementById("services");
    scroll.scrollTo(nextSection.offsetTop, {
      smooth: true,
      duration: 1000,
    });
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    gsap.fromTo(
      btnHouseRef.current,
      { y: 50, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, delay: 0.8 }
    );

    if (arrowBtnRef.current) {
      const circle = arrowBtnRef.current.querySelector('circle');
      const length = circle.getTotalLength();

      circle.style.strokeDasharray = length;
      circle.style.strokeDashoffset = length;

      gsap.to(circle, {
        strokeDashoffset: 0,
        duration: 1,
        delay: 1,
        ease: 'power2.inOut',
      });
    }

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const textAnimation = {
    hidden: { y: 20, opacity: 0 },
    visible: (i) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: 0.8,
        duration: 0.6,
      },
    }),
  };

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start end", "end start"]
  });

  const y = useTransform(scrollYProgress, [0, 1], ["-40%", "20%"]); 



  return (
    <section ref={containerRef} className="Banner h-screen mb-2 relative overflow-hidden">
      <div className='absolute top-0 left-0 w-full h-screen overflow-hidden z-10 ban_img'>
        <motion.div
          className='w-full h-screen'
          style={{ y }}
        >
          <img className='w-full h-full object-cover banr_img' src={Image} alt="House Banner" />
        </motion.div>
      </div>

      <div className="relative z-20">
        <Header className="absolute top-0 w-full mt-2"/> 

        <div className="flex flex-col lg:flex-row h-[70vh] mt-20 ">
          <div className="text-white text-left xl:max-w-[480px] lg:max-w-[480px] md:max-w-[480px] w-[230px] banr_desc
            xl:mt-20 lg:mt-20 md:mt-[4rem] sm:mt-[32px] mt-20
            xl:ml-26 lg:ml-12 md:ml-12 sm:ml-[2rem] mx-auto flex-1 z-30">
            <div className="txt" style={{ position: 'relative', zIndex: 30 }}>
              {["Real estate is a growing, regulated sector", "that is generally constantly increasing.", "At Estateland we've developed a hobby by", "helping communities to find their homes."].map((text, index) => (
                <motion.p key={index} custom={index} initial="hidden" animate="visible" variants={textAnimation} className="font-light text-left mx-auto">
                  {text}
                </motion.p>
              ))}
            </div>
            <div className="flex flex-row justify-end">
              <button
                ref={arrowBtnRef}
                className="arrow-btn rounded-full w-20 h-20 flex items-center justify-center lg:mr-20 md:mr-2 sm:mr-2 mr-2 mt-8 hover:bg-indigo-700  duration-500 hover:text-white"
                onClick={scrollToNextSection}
              >
                <svg className="w-30 h-30 md:text-white" viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="45" stroke="rgba(39, 68, 236, 0.767)" strokeWidth="1" fill="transparent" />
                </svg>
                <IoIosArrowDown className="absolute w-10 h-10 md:text-white" />
              </button>
            </div>
          </div>

          <div className={`btn_list flex ${isMobile ? "items-center justify-center" : "items-end ml-auto"} mr-${isMobile ? "0" : "20"} lg:mr-8 md:mr-8 sm:mr-12`} ref={btnHouseRef}>
            <Link to="/house-list">
              <button className="relative border border-indigo-700 bg-transparent 
              px-6 py-[0.1rem] font-medium text-white rounded-full backdrop-blur-xl transition-all duration-500 overflow-hidden
              before:absolute before:inset-0 before:bg-indigo-700 before:scale-x-0 before:origin-left before:transition-transform
              before:duration-500 before:z-[-1] hover:text-white hover:before:scale-x-100"> 
                <p className="text-[1rem]">Find your home</p>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;